import { DocumentReference, getDoc } from 'firebase/firestore'

export const getDocRef = async (docRef: DocumentReference) => {
  const response = await getDoc(docRef)
  return response.data()
}
